'use client';

import { Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

import { LeaseContext } from './Context';
import { formatPrice } from './utils';

export default function RequestLeaseAmount() {
  const { Trans, t } = useTranslation('webshop.business.leasing.actionButton');
  const { selectedLeaseAmount, legacyLeaseAmount, isLegacyLeaseFlow } = useContext(LeaseContext);
  const leaseAmount = isLegacyLeaseFlow ? legacyLeaseAmount : selectedLeaseAmount;

  if (!leaseAmount) {
    return null;
  }

  return (
    <Typography sx={{ display: 'flex', alignItems: 'baseline' }} m={0}>
      <Trans
        t={t}
        i18nKey='offer'
        components={{
          strong: <Typography component='strong' fontWeight='bold' fontSize='2xl' mr={100} />
        }}
        values={{
          price: formatPrice(leaseAmount)
        }}
      />
    </Typography>
  );
}
